var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"diff d-flex"},[_c('json-compare',{attrs:{"oldData":_vm.newest,"newData":_vm.oldest}}),_c('json-compare',{attrs:{"oldData":_vm.oldest,"newData":_vm.newest}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }